<template lang="html">
  <header id="header">
    <div class="header-content">

      <!-- Header menu -->
      <div class="header-menu">
        <b-navbar toggleable="lg" type="light" variant="light">
          <div class="container oversized-container">
            <b-navbar-brand to="/">
              <img src="public/images/logo-2.svg">
            </b-navbar-brand>

            <b-navbar-toggle target="nav-collapse"><i class="far fa-bars icon"></i></b-navbar-toggle>

            <b-collapse id="nav-collapse" is-nav>
              <b-navbar-nav class="ml-auto">
                <b-nav-item class="d-lg-none d-xl-inline-flex item-simple" to="/">Inicio</b-nav-item>
                <li class="nav-item item-simple">
                  <a class="nav-link" @click="isHActive = !isHActive">Productos <i class="fas fa-chevron-down submenu-icon"></i></a>
                </li>

                <!-- <b-nav-item-dropdown class="item-simple no-dropdown-icon" right>
                  <template #button-content>
                    <span>Productos <i class="fas fa-chevron-down submenu-icon"></i></span>
                  </template>
                  <b-dropdown-item href="#" @click="isHActive = !isHActive">Categoria 1</b-dropdown-item>
                  <b-dropdown-item href="#" @click="isHActive = !isHActive">Categoria 2</b-dropdown-item>
                </b-nav-item-dropdown> -->

                <!-- <b-nav-item class="item-simple" to="/promociones">Promociones</b-nav-item> -->
                <!-- <b-nav-item class="item-simple" to="/masnuevo">Lo + nuevo</b-nav-item> -->
                <b-nav-item class="item-simple" to="/servicios">Servicios</b-nav-item>
                <b-nav-item class="item-simple" to="/empresa">Empresa</b-nav-item>
                <b-nav-item class="item-simple" to="/contacto">Contacto</b-nav-item>

                <b-nav-item class="d-lg-none item-simple" to="/login" v-if="!$root.logged"><i class="fa-regular fa-user _icon"></i> Log in</b-nav-item>
                <b-nav-item class="d-lg-none item-simple" to="/registrarse" v-if="!$root.logged"><i class="fa-regular fa-user-plus _icon"></i> Registrarse</b-nav-item>
                <b-nav-item class="d-lg-none item-simple" to="/usuario" v-if="$root.logged">
                  <div>
                    <i class="fa-solid fa-user _icon"></i> Bienvenido <strong>{{$root.user.name}}</strong><br />
                    <span>Mi cuenta</span>
                  </div>
                </b-nav-item>

                <b-nav-item class="d-lg-none item-simple" to="/cart"><i class="fa-sharp fa-regular fa-cart-shopping _icon"></i> Carrito</b-nav-item>
              </b-navbar-nav>

              <!-- Right aligned nav items -->
              <!-- <b-navbar-nav class="ml-auto">
                <b-nav-item class="item-sm" to="/nosotros">Sobre nosotros</b-nav-item>
                <b-nav-item class="item-sm" to="">Comparar</b-nav-item>
                <b-nav-item class="item-sm" to="/contacto">Contáctanos</b-nav-item>

                <li class="d-lg-none nav-item item-line">
                  <a class="nav-link"><hr class="my-0" /></a>
                </li>
                <b-nav-item class="d-lg-none item-simple" to="/login" v-if="!$root.logged"><i class="far fa-user"></i> Iniciar sesión</b-nav-item>
                <b-nav-item class="d-lg-none item-simple" to="/registrarse" v-if="$root.logged"><i class="fas fa-user"></i> Registrarse</b-nav-item>
                 <b-nav-item class="d-lg-none item-simple" to="/usuario" v-if="$root.logged"><i class="fas fa-users-cog"></i> Mi cuenta</b-nav-item>
              </b-navbar-nav> -->
            </b-collapse>
          </div>
        </b-navbar>
      </div>
      <!--  -->

      <!-- Header options  -->
      <div class="header-options">
        <!-- <b-navbar toggleable="lg" type="dark" variant="info"> -->
        <b-navbar type="dark" variant="info">
          <div class="container oversized-container">
            <b-collapse is-nav>
              <b-navbar-nav>
                <b-nav-form class="search-form" @submit="onSubmitSearch">
                  <b-form-input placeholder="Busca producto..." v-model="formSearch.keywords" minlength="3" required></b-form-input>

                  <b-form-select v-model="formSearch.category" >
                    <b-form-select-option :value="null">Todas las opciones</b-form-select-option>
                    <b-form-select-option v-for="(subcat,indx) in subcategories" :key="'indx-'+indx" :value="subcat.id">{{subcat.name}}</b-form-select-option>
                  </b-form-select>

                  <b-button class="btn-search" type="submit"><span class="d-none d-sm-inline">Buscar</span><i class="fas fa-search d-sm-none"></i></b-button>
                </b-nav-form>
              </b-navbar-nav>

              <b-navbar-nav class="ml-auto navbar-nav-options">
                <!-- <b-nav-item class="icon-item" to="/mis-favoritos"><img src="public/images/shared/ic-favorites.svg"></b-nav-item> -->
                <b-nav-item class="icon-item cart" to="/cart"><div><i class="fa-light fa-cart-shopping cart-icon"></i> <u>{{$root.cartCount}}</u></div></b-nav-item>
                <b-nav-item class="item-simple" to="/login" v-if="!$root.logged">Log in</b-nav-item>
                <b-nav-item class="item-simple" to="/registrarse" v-if="!$root.logged">Registrarse</b-nav-item>
                 <b-nav-item class="item-simple my-account" to="/usuario" v-if="$root.logged">
                  <div>
                    Bienvenido <strong>{{ shortName($root.user.name) }}</strong><br />
                    <span>Mi cuenta</span>
                  </div>
                  <div class="ic-profile"></div>
                </b-nav-item>
              </b-navbar-nav>
            </b-collapse>
          </div>
        </b-navbar>
      </div>
      <!--  -->

    </div>

    <!-- Categorías -->
    <div class="t-250 products-menu" v-bind:class="{ active: isHActive }">
      <div class="menu-bg" @click="isHActive = false"></div>

      <div class="tablist" role="tablist">
        <div class="t-250 box-title" @click="isHActive = false">
          <h4>CATEGORÍAS</h4>
          <!-- <br>
          <h5 v-on:click="$router.push('/productos');">Categorias</h5> -->
          <!-- <i class="fas fa-chevron-left icon"></i> -->
          <i class="fas fa-chevron-square-left icon"></i>
        </div>

        <b-card no-body class="mb-1" v-for="(category, pcatIndex) in categories" :key="pcatIndex">
          <b-card-header header-tag="header" role="tab">
            <!-- <div v-if="category.subcategories" class="btn-toggle">
              <router-link :to="'/categoria/'+$root._converToURL(category.name, category.id)">{{ category.name }}</router-link>
              <span class="fake-toggle" v-b-toggle="'accordion-'+pcatIndex"></span>
            </div>
            <router-link v-else class="btn-toggle" :to="'/categoria/'+$root._converToURL(category.name, category.id)">{{ category.name }}</router-link> -->
            <a class="btn-toggle" v-b-toggle="'accordion-'+pcatIndex" style="text-decoration: none !important;">{{ category.name }}</a>
          </b-card-header>

          <b-collapse v-if="category.subcategories" :id="'accordion-'+pcatIndex" visible accordion="my-accordion" role="tabpanel">
            <b-card-body>
              <ul class="ul-sub-options">
                <li v-for="subcategory in category.subcategories">
                  <router-link class="t-250" :to="'/subcategoria/'+$root._converToURL(subcategory.name, subcategory.id)">{{ subcategory.name }}</router-link>
                </li>
              </ul>
            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </div>
    <!--  -->

  </header>
</template>

<script>
export default {
  data(){
    return{
      isHActive: false,

      categories: [
        // { id: 6, name:'Soportes de Motor' },
        // { id: 6, name:'Soportes de Transmisión' },
        // { id: 6, name:'Cubre polvos y/o Machetas' },
        // { id: 6, name:'Bases de amortiguador' },
        // { id: 6, name:'Repuestos de Soportes' },
        // { id: 6, name:'Mangueras para Radiador' },
        // { id: 6, name:'Mangueras del Cuerpo de Aceleración' },
        // { id: 6, name:'Mangueras de Vació' },
        // { id: 6, name:'Mangueras de Gasolina' },
        // { id: 6, name:'Bandas Automotrices e Industriales' },
        // { id: 6, name:'Hules de Barra' },
        // { id: 6, name:'Hules de Poliuretano' },
        // { id: 6, name:'Hules de Escape' },
        // { id: 6, name:'Hules de Cremallera' },
        // { id: 6, name:'Hules de Muey Agregar' },
        // { id: 6, name:'Hules de amortiguador' },
        // { id: 6, name:'Calzas' },
        // { id: 6, name:'Casetas' },
        // { id: 6, name:'Hule Pela Pollos' },
        // { id: 6, name:'Sordinas' },
        // { id: 6, name:'Regatones' },
        // { id: 6, name:'Coples y Galletas de Dirección' },
        // { id: 6, name:'Codos' },
        // { id: 6, name:'Fuelles' },
        // { id: 6, name:'Hules Misceláneos' },
        // { id: 6, name:'Placas de quinta rueda' },
        // { id: 6, name:'Hules de pedal modificar (antes pedales)' },
        // { id: 6, name:'Depósitos de Anticongelante' },
        // { id: 6, name:'Radiadores eliminar' },
        // { id: 6, name:'Poleas de Accesorios y/o Poleas de Distribución' },
        // { id: 6, name:'Tensores de accesorios modificar (antes tensores)' },
        // { id: 6, name:'Tubos de enfriamiento modificar (antes tubo de agua)' },
        // { id: 6, name:'Termostatos' },
        // { id: 6, name:'Bombas de Agua' },
        // { id: 6, name:'Tomas de Agua' },
        // { id: 6, name:'Anticongelante' },
        // { id: 6, name:'Tapas de punterías Agregar' },
        // { id: 6, name:'Enfriadores de Aceite Agregar' },
        // { id: 6, name:'Cabezas de motor Agregar' },
        // { id: 6, name:'Actuadores tensores hidráulicos de distribución Agregar' },
        // { id: 6, name:'KITS de banda de districión Agregar' },
        // { id: 6, name:'Multiples de Admisión Agregar' },
        // { id: 6, name:'Empaques de Puerta' },
        // { id: 6, name:'Empaques de Cajuela' },
        // { id: 6, name:'Cañuelas' },
        // { id: 6, name:'Empaques planos' },
        // { id: 6, name:'Hule Pasillo' },
        // { id: 6, name:'Neopreno' },
        // { id: 6, name:'Nitrilo Sanitario' },
        // { id: 6, name:'Tapete para Caballo' },
        // { id: 6, name:'Anti fatigas' },
        // { id: 6, name:'Picos de Pájaro' },
        // { id: 6, name:'Topes de Rebote' },
        // { id: 6, name:'Loderas' },
        // { id: 6, name:'Topes de Estacionamiento' },
        // { id: 6, name:'Topes de defensa Agregar' },
        // { id: 6, name:'Tapetes Automotrices' },
        // { id: 6, name:'Limpiaparabrisas' },
        // { id: 6, name:'Pegamento Automotriz' },
        // { id: 6, name:'Abrazaderas' },
        // { id: 6, name:'Grapas Automotrices' },
        // { id: 6, name:'Autopartes' },
        // { id: 6, name:'Ligas O-ring modificar (antes ligas)' },
      ],

      subcategories: [],

      formSearch: {
        keywords: null,
        category: null
      },

    }
  },

  methods: {
    onSubmitSearch(event) {
      event.preventDefault();

      this.$router.push({path: '/busqueda', query: {keywords:this.formSearch.keywords,category:this.formSearch.category}});
    },

    shortName(name) {
      const count = Array.from(name).length;

      if(count <= 20) {
        return name;
      }else {
        let newName = name.slice(0, 19);
        newName = newName + ".";

        return newName;
      }
    },
    
    getCategories(){
      axios.get(tools.url("/api/categories")).then((response)=>{
        this.categories = response.data.categories;
        this.subcategories = response.data.subcategories;
        this.$parent.inPetition=false;
      }).catch((error)=>{
        console.error(error);
      });
    },
  },

  watch: {
    $route (to, from){
      // Ocultar menu cada vez que cambie la ruta
      this.isHActive = false;
    }
  },
  mounted(){
    this.getCategories();
  }
}
</script>
